import React from 'react';
import { HeroSection } from '../components/sections/HeroSection';
import { ProblemSection } from '../components/sections/ProblemSection';
import { SolutionSection } from '../components/sections/SolutionSection';
import { ResultsSection } from '../components/sections/ResultsSection';
import { AudienceSection } from '../components/sections/AudienceSection';
import { BenefitsSection } from '../components/sections/BenefitsSection';
import { CredibilitySection } from '../components/sections/CredibilitySection';
import { PricingSection } from '../components/sections/PricingSection';
import { HowItWorksSection } from '../components/sections/HowItWorksSection';
import { TestimonialSection } from '../components/sections/TestimonialSection';
import { FAQSection } from '../components/sections/FAQSection';
import { FooterSection } from '../components/sections/FooterSection';
export function LandingPage() {
  return <main className="min-h-screen bg-background text-gray-700 font-body selection:bg-primary/30 selection:text-white" data-id="element-309">
      <HeroSection data-id="element-310" />
      <ProblemSection data-id="element-311" />
      <SolutionSection data-id="element-312" />
      <AudienceSection data-id="element-313" />
      <ResultsSection data-id="element-314" />
      <BenefitsSection data-id="element-315" />
      <PricingSection data-id="element-316" />
      <CredibilitySection data-id="element-317" />
      <HowItWorksSection data-id="element-318" />
      <TestimonialSection data-id="element-319" />
      <FAQSection data-id="element-320" />
      <FooterSection data-id="element-321" />
    </main>;
}